import { bind } from 'decko'
import { LiveElement } from 'live-node-list'

export default class LanguageSwitcher {

  /**
   * @type {LiveElement}
   */
  languageSwitcherForm = new LiveElement('.language-switcher form')

  /**
   *
   */
  constructor() {
    if (!this.languageSwitcherForm.item) {
      return
    }

    this.registerListeners()
  }

  @bind
  registerListeners() {
    const select = this.languageSwitcherForm.item.querySelector('select')

    select.addEventListener('change', e => {
      this.languageSwitcherForm.item.submit()
    })
  }
}
